import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { title } from 'process';
import { AuthService } from 'src/app/feature/auth/services/auth.service';

interface RouteItem {
  link: string;
  permission?: string;
}

interface DropdownModule {
  hasAccess: boolean;
  status_dropdown: boolean;
  listRoute: Record<string, RouteItem>;
}

@Component({
  selector: 'app-menu-sidebar',
  templateUrl: './menu-sidebar.component.html',
  styleUrls: ['./menu-sidebar.component.scss']
})
export class MenuSidebarComponent implements OnInit {
  @Input() is_close_sidebar_menu: boolean = false;
  @Output() is_close_sidebar_menuChange = new EventEmitter<boolean>();


  listDropdown: Record<string, DropdownModule> = {
    karyawan_module: {
      hasAccess: false,
      status_dropdown: false,
      listRoute: {
        Cabang: { link: '/hr/karyawan/master-cabang', permission: 'cabang.access' },
        Karyawan: { link: '/hr/karyawan/master-karyawan', permission: 'karyawan.access' },
        Kontrak_Karyawan: { link: '/hr/karyawan/kontrak-karyawan', permission: 'kontrak_karyawan.access' },
        Mutasi_Karyawan: { link: '/hr/karyawan/mutasi-karyawan', permission: 'mutasi_karyawan.access' }
      }
    },
  };



  typeModule: string;
  listTypeModule = []; // DIdisi lewat init

  listTypeModuleTemp = [
   
  ];


  constructor(
    private router: Router,
    public authService: AuthService
  ) {


  }

  ngOnInit(): void {
    this.checkModuleCanAccess();

    this.router.events.subscribe(event => {
      if (event instanceof NavigationEnd) {
        this.checkCurrentRoute();
      }

    });
    this.checkCurrentRoute();
  }


  checkCurrentRoute(): void {
    const currentRoute = this.router.url;

    const innerWidth = window.innerWidth;
    if (innerWidth > 868 && !this.is_close_sidebar_menu) {
      Object.keys(this.listDropdown).forEach(key => {
        this.listDropdown[key].status_dropdown = Object.values(this.listDropdown[key].listRoute)
          .some(routeUrl => currentRoute?.startsWith(routeUrl?.link));
      });
    }

  }

  checkModuleCanAccess() {
    this.authService.getProfile().subscribe((user: any) => {
      this.listTypeModule = []; // Pastikan list kosong sebelum diisi ulang

      const moduleCanAccess = Array.isArray(user?.moduleCanAccess) ? user.moduleCanAccess : [];

      Object.values(this.listTypeModuleTemp).forEach(item => {
        if (moduleCanAccess.includes(item.name)) {
          this.listTypeModule.push(item);
        }
      });

      // Ambil module aktif dari localStorage
      const storedModule = localStorage.getItem('active_module');

      // Tentukan module default
      if (storedModule && this.listTypeModule.some(item => item.name === storedModule)) {
        this.typeModule = storedModule;
      } else {
        this.typeModule = this.listTypeModule.length > 0 ? this.listTypeModule[0].name : null;
        if (this.typeModule) {
          localStorage.setItem('active_module', this.typeModule);
        }
      }

      // Khusus pengaturan tidak dimasukakn ke localstorage
      const currentRoute = this.router.url;
      const isPengaturan = currentRoute.startsWith('/pengaturan');
      if (isPengaturan) {
        this.typeModule = 'pengaturan'
      }
      //

    });
  }

  checkPermoduleModuleAccess(moduleKey: string): boolean {
    const module = this.listDropdown[moduleKey];
    if (!module) return false;

    return Object.values(module.listRoute).some(route =>
      this.authService.checkAccess(route.permission)
    );
  }



  toggleDropdown(menu: string): void {
    this.listDropdown[menu].status_dropdown = !this.listDropdown[menu].status_dropdown;
  }


  btnCloseSidebar() {
    this.is_close_sidebar_menu = !this.is_close_sidebar_menu;
    this.is_close_sidebar_menuChange.emit(this.is_close_sidebar_menu);


    if (!this.is_close_sidebar_menu) {
      this.checkCurrentRoute();
    } else {
      Object.keys(this.listDropdown).forEach(key => {
        this.listDropdown[key].status_dropdown = false;
      });
    }
  }




  followedMenuLinkTop = 0;
  fixedElementTop = 0;
  onHover(menu_name: string) {
    if (this.is_close_sidebar_menu) {
      const menuLinkElement = document.getElementById(`menuLink_${menu_name}`) as HTMLElement;
      const subMenuLinkElement = document.getElementById(`subMenu_${menu_name}`) as HTMLElement;

      if (!menuLinkElement || !subMenuLinkElement) return;

      const rect = menuLinkElement.getBoundingClientRect();
      this.followedMenuLinkTop = rect.top + window.scrollY + menuLinkElement.offsetHeight;

      subMenuLinkElement.style.top = `${this.followedMenuLinkTop - 50}px`;
      this.listDropdown[menu_name].status_dropdown = true;

      console.log(this.followedMenuLinkTop - 50);

    }
  }

  onHoverOut(menu_name: string) {
    if (this.is_close_sidebar_menu) {
      this.listDropdown[menu_name].status_dropdown = false;
    }
  }
  setModuleActive() {
    localStorage.setItem('active_module', this.typeModule);
    window.location.replace('/');

  }
  changeModuleWithReload(route) {
    console.log(route);
    this.router.navigateByUrl(route).then(() => {
      
      window.location.reload();
    });
  }



}
